import React from 'react';
import { sizes } from 'helpers/MediaHelper';

import { FilePreview } from './FilePreview';

import {
  StyledOuterContainer,
  StyledDropzone,
  StyledContainer,
  StyledDropzoneText,
  StyledDropHereText,
  StyledSpan,
  StyledBrowseFileText,
  StyledDropIcon,
  StyledError,
} from './SingleFileUpload.styles';

const SingleFileUpload = ({
  file,
  data,
  onChange,
  onDropVerbiage,
  dropFileVerbiage,
  browseVerbiage,
  acceptedFiles,
  rejectFileError,
  maxSize = 24000000,
  FileDropIcon,
  disabled,
  ...rest
}) => {
  const isMobile = window.matchMedia(`(max-width: ${sizes.mobile}px)`).matches;

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      onChange(acceptedFiles[0]);
    }
  };

  const removeFile = () => () => {
    onChange(null);
  };

  return (
    <StyledOuterContainer {...rest}>
      {!disabled && (
        <StyledContainer>
          <StyledDropzone onDrop={onDrop} accept={acceptedFiles} maxSize={maxSize} multiple={false}>
            {({ isDragActive, rejectedFiles }) => (
              <React.Fragment>
                {isDragActive ? (
                  <StyledDropHereText isDragActive={isDragActive}>
                    {onDropVerbiage}
                  </StyledDropHereText>
                ) : (
                  <StyledDropzoneText>
                    <StyledDropHereText>
                      {FileDropIcon ? <FileDropIcon /> : <StyledDropIcon />}
                      {!isMobile && <StyledSpan>{dropFileVerbiage}</StyledSpan>}
                    </StyledDropHereText>
                    <StyledBrowseFileText>{browseVerbiage}</StyledBrowseFileText>
                  </StyledDropzoneText>
                )}
                {rejectedFiles.length > 0 && <StyledError>{rejectFileError}</StyledError>}
              </React.Fragment>
            )}
          </StyledDropzone>
        </StyledContainer>
      )}
      {file && <FilePreview file={file} removeFile={removeFile} disabled={disabled} />}
    </StyledOuterContainer>
  );
};

export default SingleFileUpload;
